<!-- eslint-disable vue/multi-word-component-names -- Existing component, kept for backward compatibility -->
<template>
    <svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10" fill="none">
        <path
            d="M9.4773 4.73865C9.4773 7.35573 7.35573 9.4773 4.73865 9.4773C2.12157 9.4773 0 7.35573 0 4.73865C0 2.12157 2.12157 0 4.73865 0C7.35573 0 9.4773 2.12157 9.4773 4.73865ZM4.73865 2.07316C4.73865 1.90959 4.60605 1.77699 4.44248 1.77699C4.27892 1.77699 4.14632 1.90959 4.14632 2.07316V5.33098C4.14632 5.43726 4.20327 5.53539 4.29554 5.58812L6.3687 6.77279C6.51072 6.85394 6.69163 6.8046 6.77279 6.66258C6.85394 6.52057 6.8046 6.33965 6.66258 6.2585L4.73865 5.15911V2.07316Z"
            fill="currentColor" />
    </svg>
</template>
